// extracted by mini-css-extract-plugin
export var btn = "R_mB F_vt F_vg d_by d_bN d_bC d_dv";
export var full = "R_xT d_v d_G";